import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { ScrollDispatcher } from '@angular/cdk/overlay';
import data from 'src/assets/json/states.json';
import { QBOEnvironment } from 'src/environments/environment';
import { BrooklynBillStatus, ResponseStatus, ValidationMessage } from '../../enum';
import { holidayArray } from 'src/assets/HolidaySchedule/holidays';
@Component({
  selector: 'app-add-update-bills',
  templateUrl: './add-update-bills.component.html',
  styleUrls: ['./add-update-bills.component.scss'],

  standalone: false,
})
export class AddUpdateBillsComponent implements OnInit {
  isVisibleBillModal = true;
  isBillSkeleton = false;
  isLoadingOne = false;
  isLoadingUnlink = false;
  isLoadingMap = false;
  isLoadingQBOLink = false;
  amountNumber: any;
  loadingNewVendor = false;
  isloadingUnderReviewPayment = false;
  getPaymentDetail: any;
  serviceFee: any;
  NetAmount: any;
  tabIndex: any;
  listOfAllQBOVendor: any;
  isLoadingTags: any = false;
  selectedTagGroup: any = '';
  mapVendorQboId: any;
  qboOriginalbillLink: any = '';
  filetype: any = '';
  nonalcResult: any = '';
  vendorDropDownLink: any = '';
  // holidayArray: any[] = [];
  isLoadingVendor: any;
  getUploadedBillAttachment: any;
  getUploadedBillAttachmentUrl: any;
  getUploadedBillAttachmentName: any;
  getUploadedW9AttachmentUrl: any;
  getUploadedW9AttachmentName: any;
  isResyncingData: boolean = false;

  estDeliveryDate: any;
  listOfStates: any = data.States;
  listOfServiceType: any = [
    { id: '1', name: 'Next-day Payment' },
    { id: '2', name: 'Standard Service' },
    { id: '3', name: 'Wire Transfer' },
  ];
  listOfPaymentType: any = [
    { id: '1', name: 'ePayment' },
    { id: '2', name: 'Credit Card' },
    { id: '3', name: 'Check' },
    { id: '4', name: 'Wire Transfer' },
  ];
  netTerms: any = 'Due on receipt';

  isloadingApproveBill: any = false;
  isloadingAddUpdate: any = false;
  listOfProductService: any;
  vendorBillDetails: any;
  listOfTransactionClass: any;
  listOfTerms: any;
  listOfCategory: any;
  uploadFlagW9Attachment: any = false;
  uploadFlagBillAttachment: any = false;
  amount: any;
  isLoadingPrograms: any;
  isLoadingSites: any;
  vendorDetails: any;
  listOfProgramPeriods: any;
  getSiteDetails: any;
  selectedTag: any;
  getAllSiteSelectedpartner: any;
  vendorId: any;
  siteId: any = '';
  serviceType: any;
  currentInvoiceAmount: any;
  currentQBOInvoiceAmount: any
  currentBillServiceFee: any = 0;
  currentQBOBillServiceFee: any = 0
  paymentType: any = 'check';
  mapValue: any = 'A';
  LineStreetAddress: any = false;
  LineStreetAddressQbo: any = false;
  isTransactionProcessing = false;
  allowedTypes = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.ms-excel',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  uploadedFile: any = '';
  uploadedFileW9Attachment: any;
  isMarkingReviewed: boolean = false;
  @Output() hideExpenseDrawer = new EventEmitter();
  @Input() selectedData: any;
  listOfUsersSites: any = [];
  ListFile: any = [];
  listOfTags: any[] = [];
  lastScrollTop: any;
  qboURL = QBOEnvironment.URL;
  deleteConfirmVisible: boolean = false;
  @ViewChild('tagsDD') tagsDD: any;
  @ViewChild('ptype') ptype: any;
  @ViewChild('vendorDD') vendorDD: any;
  @ViewChild('zipcode') zipcode: any;
  @ViewChild('vendorName') vendorName: any;
  @ViewChild('zipcodeVendor') zipcodeVendor: any;
  @ViewChild('businessNo') businessNo: any;
  @ViewChild('billNo') billNo: any;
  validationMessage = ValidationMessage;
  listOfUnfilteredTags: any[] = [];
  isConfirmUnderReviewVisible: boolean;
  pdfZoom: number = 1;
  /**
   * Completes nz-upload locally so (nzChange) emits success/error.
   * Real blob upload happens in handleChangeUpload via PaybevBillAttachment.
   */
  billAttachmentUploadRequest = (item: {
    file: NzUploadFile;
    onSuccess?: (body: unknown, file: NzUploadFile, xhr?: unknown) => void;
  }): void => {
    setTimeout(() => {
      item.onSuccess?.({}, item.file);
    }, 0);
  };

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private datepipe: DatePipe,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public scroll: ScrollDispatcher,
    private currency: CurrencyPipe
  ) {
    _fS.billSiteVendorForm_fb();
    _fS.billNewQbVendorForm_fb();
    _fS.billPaybevInvoiceForm_fb();
    _fS.billForm_fb();
  }
  ngOnInit(): void {
    this.getGenericPopulateRecords();
    this.GetUserSites();
    this.loadPrograms('');

    if (this.selectedData != null) {
      this.getPaymentDetails();
      this.vendorDropdownListBySiteId();
    }
    // else {
    //   this._fS.billPaybevInvoiceForm.patchValue({
    //     serviceRequest: String(this.serviceType),
    //   });
    // }
  }
  getUnderReviewReasons() {
    this._cpS.getAllPaymentUnderReview().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfUnderReviewReasons = response.result;

        // if (!this.getPaymentDetail?.underReviewInfo?.isMarkedAsUnderReview) {
        //   this.currentReviewReason = this.listOfUnderReviewReasons[0];
        //   this.reviewReason = this.listOfUnderReviewReasons[0]?.id;
        // }
      }
    });
  }
  handleCancel(data: any) {
    this.isVisibleBillModal = false;
    this.hideExpenseDrawer.emit({ hide: this.isVisibleBillModal, data: data });
  }
  getGenericPopulateRecords() {
    this._cpS.getGenericPopulateRecords('1').subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfCategory = response.result.category;
        this.listOfProductService = response.result.service;
        this.listOfTransactionClass = response.result.class;
        this.listOfTerms = response.result.term;
      }
    });
  }
  tofixed() {
    // this._fS.billPaybevInvoiceForm.set('amount').value = parseFloat(this._fS.billPaybevInvoiceForm.get('amount').value).toFixed(2)
    // this._fS.billPaybevInvoiceForm.patchValue({
    //   amount: parseFloat(this._fS.billPaybevInvoiceForm.get('amount').value).toFixed(2),
    // });
  }
  GetUserSites() {
    this.isLoadingSites = true;
    this._cpS.GetUserSites(false).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isLoadingSites = false;
        this.listOfUsersSites = response.result;
      }
    });
  }
  vendorDropdownListBySiteId() {
    this._cpS.GetQBOVendorDropdownList().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfAllQBOVendor = response.result;
      }
    });
  }

  getVendorDetails() {
    this._cpS.GetVendor(this.mapVendorQboId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.vendorDetails = response.result;
      }
    });
  }
  markExpenseUnderReview() {
    this.isConfirmUnderReviewVisible = true;
  }
  currentReviewReason: any;
  listOfUnderReviewReasons: any[] = [];
  reviewReason: any;
  underReviewReasonChange() {
    this.currentReviewReason = this.listOfUnderReviewReasons.find(
      (x: any) => x.id == this.reviewReason
    );
  }
  updateTransactionWithUnderRviewReason(isUnderReview: boolean) {
    if (isUnderReview && !this.reviewReason) {
      this._cS.displayMessage(
        'warning',
        'Please select a reason to mark as under review'
      );
    } else {
      this.isMarkingReviewed = true;
      if (!isUnderReview) {
        // this.reviewReason = this.getPaymentDetail.underReviewInfo.id;
        this.currentReviewReason = this.getPaymentDetail.underReviewInfo;
      }
      // else{
      //   this.currentReviewReason = this.listOfUnderReviewReasons.find(
      //     (x: any) => x.id == this.getPaymentDetail.underReviewInfo.id
      //   );
      // }

      var requestBody = {
        id: this.selectedData.id,
        transactionType: 2,
        underReviewId: this.currentReviewReason.id,
        reason: this.currentReviewReason.reason,
        color: this.currentReviewReason.color,
        isMarkedAsUnderReview: isUnderReview,
        emailCopy: this.currentReviewReason.emailCopy,
      };
      this._cpS
        .updateTransactionUnderReview(requestBody)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this._cS.displayMessage('success', response.message);
            this.isMarkingReviewed = false;
            this.isConfirmUnderReviewVisible = false;
            this.getPaymentDetail.underReviewInfo = {
              id: this.currentReviewReason.id,
              reason: this.currentReviewReason.reason,
              color: this.currentReviewReason.color,
              isMarkedAsUnderReview: isUnderReview,
              emailCopy: this.currentReviewReason.emailCopy,
            };
            this.reviewReason = '';
            // this.isVisibleBillModal = false;
            // this.hideExpenseDrawer.emit({
            //   hide: this.isVisibleBillModal,
            //   data: response.result,
            // });
            this._cS.underReviewCount.next('call');
          } else {
            this._cS.displayMessage('error', response.message);
            this.isMarkingReviewed = false;
          }
        });
    }
  }
  saveVendor() {
    if (this._fS.billNewQbVendorForm.valid) {
      const formValue = this._fS.billNewQbVendorForm.value;
      var selectedPaymentType = this.listOfPaymentType?.find(
        (x: any) => x.id == formValue.paymentType
      );
      var selectedNetTerms = this.listOfTerms?.find(
        (x: any) => x.id == formValue.netTerms
      );

      var vendorBody = {
        paymentId: this.selectedData.id,
        companyName: formValue.companyName,
        isTrackPaymentFor1099: formValue.trackPayment,
        vendorName: formValue.vendorName,
        streetAddress1: formValue.address1,
        streetAddress2: formValue.address2,
        isAddLine: this.LineStreetAddressQbo ? true : false,
        city: formValue.city,
        state: formValue.state,
        zipCode: formValue.zipcode,
        country: formValue.country,
        email: formValue.emailAddress,
        businessNumber: formValue.BusinessRegNo,
        phoneNumber: formValue.phoneNumber,
        mobileNumber: formValue.mobileNumber,
        terms: {
          id: formValue.netTerms,
          name: selectedNetTerms.name,
        },
        paymentType: {
          id: formValue.paymentType,
          name: selectedPaymentType.name,
        },
      };
      this.addNewVendor(vendorBody);
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.billNewQbVendorForm.controls).forEach(
        (control: any) => {
          if (control.invalid) {
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
        }
      );
    }
  }

  addNewVendor(vendorBody: any) {
    this.loadingNewVendor = true;
    this._cpS.AddNewVendor(vendorBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);

          this.getPaymentDetail = response.result;
          this.paymentType =
            this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails
              ?.paymentType?.name != null
              ? this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails
                ?.paymentType?.name
              : 'Check';
          this.loadingNewVendor = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.loadingNewVendor = false;
        }
      },
      (error: any) => {
        this.loadingNewVendor = false;
      }
    );
  }
  searchText: string = '';
  timer: any = null;

  //search supplier
  searchVendor(event: any) {
    this.searchText = event;
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      this.isLoadingVendor = true;
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.getSiteVendorDropdownList();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.getSiteVendorDropdownList();
        }
      }
    }
  }

  getSiteVendorDropdownList() {
    this.isLoadingVendor = true;
    this._cpS
      .GetSiteVendorDropdownList(this.siteId, this.searchText)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.getAllSiteSelectedpartner = response.result;
        }
        this.isLoadingVendor = false;
      });

  }

  getInvestorPaybevBySiteId() {
    if (this.siteId != '') {
      this.isLoadingVendor = true;
      if (
        this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.vendorId ==
        null
      ) {
        this._fS.billSiteVendorForm.patchValue({
          vendor: null,
        });
      }
      this._cpS
        .GetSiteVendorDropdownList(this.siteId, this.searchText)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.getAllSiteSelectedpartner = response.result;
          }
          this.isLoadingVendor = false;
        });
      this._cpS.GetSiteDetails(this.siteId).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.getSiteDetails = response.result;
          setTimeout(() => {
            this._fS.billPaybevInvoiceForm.patchValue({
              category: this.getSiteDetails?.category,
              class: this.getSiteDetails?.class,
            });
          }, 100);
        }
      });
      this.loadPrograms(this.siteId);
      this.getTags();
    }

    // this._fS.billSiteVendorForm.reset()
  }

  loadPrograms(siteId: any) {
    if (siteId) {
      this.isLoadingPrograms = true;
      this._cpS.getProgramBySite(siteId).subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.isLoadingPrograms = false;
            this.listOfProgramPeriods = response.result;
            var defaultProgram = this.listOfProgramPeriods?.find(
              (x: any) => x?.isDefault
            );
            if (this.selectedData == null) {
              this._fS.billForm.patchValue({
                programPeriod: defaultProgram?.id,
              });
            }
          } else {
            this.listOfProgramPeriods = [];
            this.isLoadingPrograms = false;
            this._cS.displayMessage('error', response.message);
          }
        },
        (error: any) => {
          this.listOfProgramPeriods = [];
          this.isLoadingPrograms = false;
        }
      );
    }
  }
  //once file gets uploaded
  handleChangeUpload(event: any): void {
    if (event) {
      if (event.type == 'success' || event.type == 'error') {
        this.getUploadedBillAttachmentName = '';
        this.getUploadedBillAttachmentUrl = null;
        if (!this.uploadedFile) {
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(this.uploadedFile);
        reader.onload = () => {
          this.uploadFlagBillAttachment = true;
          if (this.selectedData != null) {
            const formDataAttachment = new FormData();
            if (this.selectedData?.id != undefined) {
              formDataAttachment.set('PaymentId', this.selectedData?.id);
            }
            formDataAttachment.set('BillAttachment', this.uploadedFile);
            this._cpS
              .PaybevBillAttachment(formDataAttachment)
              .subscribe((response: any) => {
                if (response.responseStatus == ResponseStatus.success) {
                  this.getPaymentDetail.billDetails.paybevPayment.billAttachmentName =
                    response.result.billDetails.paybevPayment.billAttachmentName;
                  this.getPaymentDetail.billDetails.paybevPayment.billAttachmentURL =
                    response.result.billDetails.paybevPayment.billAttachmentURL;
                  // Keep a plain URL string (same as reload path). Do not wrap with
                  // getSafeUrl then concatenate — that becomes "[object Object]?t=..."
                  // and breaks immediate <img> preview for jpeg/png.
                  const attachmentName =
                    response.result.billDetails.paybevPayment.billAttachmentName ||
                    '';
                  this.getUploadedBillAttachmentName = attachmentName;
                  this.filetype = attachmentName.includes('.')
                    ? attachmentName.split('.').pop()
                    : '';
                  this.getUploadedBillAttachmentUrl =
                    response.result.billDetails.paybevPayment.billAttachmentURL +
                    '?t=' +
                    new Date().getTime();
                  // Switch to saved-attachment UI (blue open link), same as on reopen.
                  this.uploadFlagBillAttachment = false;
                  this.uploadedFile = '';
                  this._cS.displayMessage('success', response.message);
                } else {
                  this._cS.displayMessage('error', response.message);
                }
              });
          }
        };
      }
    }
  }

  //delete uploaded file
  confirmRemove() {
    this.uploadedFile = '';
    this.getUploadedBillAttachmentUrl = null;
    this.getUploadedBillAttachmentName = '';
    this.uploadFlagBillAttachment = false;
  }
  //delete uploaded file
  confirmRemoveGetBillAttachment() {
    this.getUploadedBillAttachmentName = '';
    this.getUploadedBillAttachmentUrl = null;
    this.uploadedFile = '';
    this.uploadFlagBillAttachment = false;
    if (this.getPaymentDetail?.billDetails?.paybevPayment) {
      this.getPaymentDetail.billDetails.paybevPayment.billAttachmentName = null;
      this.getPaymentDetail.billDetails.paybevPayment.billAttachmentURL = null;
    }
  }
  //delete uploaded file
  confirmRemoveGetW9Attachment() {
    this.getUploadedW9AttachmentName = '';
  }

  //delete uploaded file
  confirmRemoveBrowse() {
    this.uploadedFileW9Attachment = '';
  }

  //check type of file before it gets uploaded
  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): boolean => {
    const isJpgOrPng = this.allowedTypes.includes(file.type + '');
    const isLt2M = file.size! / 1024 / 1024 < 20;
    if (_fileList.length > 1) {
      this._cS.displayMessage('warning', 'Please upload single file!');
    } else if (!isJpgOrPng) {
      this._cS.displayMessage('warning', 'File type is not allowed!');
    } else if (!isLt2M) {
      this._cS.displayMessage(
        'warning',
        'File size must be smaller than 20MB!'
      );
    } else if (!file.size) {
      this._cS.displayMessage('warning', 'File size must be greater than 0KB!');
    } else {
      this.getUploadedBillAttachmentName = '';
      this.getUploadedBillAttachmentUrl = null;
      this.uploadedFile = '';
      this.getUploadedBillAttachmentUrl = null;
      this.getUploadedBillAttachmentName = '';
      this.uploadedFile = file;

      return true;
    }
    return false;
  };
  //check type of file before it gets uploaded
  beforeUploadW9Attachment = (
    file: NzUploadFile,
    _fileList: NzUploadFile[]
  ): boolean => {
    const isJpgOrPng = this.allowedTypes.includes(file.type + '');
    const isLt2M = file.size! / 1024 / 1024 < 20;
    if (_fileList.length > 1) {
      this._cS.displayMessage('warning', 'Please upload single file!');
    } else if (!isJpgOrPng) {
      this._cS.displayMessage('warning', 'File type is not allowed!');
    } else if (!isLt2M) {
      this._cS.displayMessage('warning', 'File must be smaller than 20MB!');
    } else if (!this._fS.billSiteVendorForm.value.vendor) {
      this._cS.displayMessage(
        'warning',
        'Please First Select Preferred Vendors'
      );
    } else {
      this.uploadedFileW9Attachment = file;
      return true;
    }
    return false;
  };

  GetSiteVendorDetailbyVendorId() {
    setTimeout(() => {
      if (this.vendorId) {
        this._cpS.GetSiteVendor(this.vendorId).subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.vendorBillDetails = response.result;
            this.focusElement(
              'event',
              (this.vendorBillDetails?.qboEntityId == null &&
                this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails
                  ?.qboVendorId == null) ||
                this.getPaymentDetail?.isVendorUpdated == true
                ? this.vendorName
                : this.billNo,
              'nativeEle'
            );

            if (this.getPaymentDetail && this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentName == null && this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentURL != null) {
              this.getPaymentDetail.vendorDetails.payBevVendorDetails.w9AttachmentName = this.vendorBillDetails.w9AttachmentName;
              this.getUploadedW9AttachmentName =
                this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentName;
            }

            if (this.getPaymentDetail && this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentName != null && this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentURL == null) {
              this.getPaymentDetail.vendorDetails.payBevVendorDetails.w9AttachmentURL = this.vendorBillDetails.w9AttachmentURL;
              this.getUploadedW9AttachmentUrl =
                this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentURL;
            }

            if (this.vendorBillDetails?.qboEntityId == null) {
              this._fS.billSiteVendorForm
                .get('vendorName')
                .addValidators(Validators.required);
              this._fS.billSiteVendorForm
                .get('address1')
                .addValidators(Validators.required);
              this._fS.billSiteVendorForm
                .get('city')
                .addValidators(Validators.required);
              this._fS.billSiteVendorForm
                .get('state')
                .addValidators(Validators.required);
              this._fS.billSiteVendorForm
                .get('zipcode')
                .addValidators(Validators.required);
              this._fS.billSiteVendorForm
                .get('country')
                .addValidators(Validators.required);
            } else {
              for (const key in this._fS.billSiteVendorForm.controls) {
                if (!(key == 'vendor' || key == 'site'))
                  this._fS.billSiteVendorForm.get(key).clearValidators();
                this._fS.billSiteVendorForm
                  .get(key)
                  .updateValueAndValidity({ onlySelf: true });
              }
            }

            this.paymentType =
              this.vendorBillDetails.paymentType != null
                ? this.vendorBillDetails.paymentType
                : 'Check';
            this.mapValueChange();
          }
          // this.isBillSkeleton = false;
        });
      }
    }, 100);
  }

  getPaymentDetails() {
    this.isBillSkeleton = true;
    this._cpS.GetPayment(this.selectedData.id).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getPaymentDetail = response.result;

        if (this.getPaymentDetail?.underReviewInfo?.isMarkedAsUnderReview) {
          this.currentReviewReason = this.getPaymentDetail?.underReviewInfo;

          // this.reviewReason = this.getPaymentDetail?.underReviewInfo?.id;
        }
        this.getUnderReviewReasons();

        this.vendorId =
          this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.vendorId;
        this._fS.billSiteVendorForm.patchValue({
          site: this.getPaymentDetail?.siteId,
          vendor:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.vendorId,
          vendorName:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails
              ?.vendorName,
          address1:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails
              ?.streetAddress1,
          address2:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails
              ?.streetAddress2,
          city: this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.city,
          state:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.state,
          zipcode:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.zipCode,
          country: this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.country,
          emailAddress:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.email,
          siteVendoremailAddress: this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.email,
          phoneNumber:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails
              ?.phoneNumber,
        });
        this.LineStreetAddress =
          this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.isAddLine;
        if (this.LineStreetAddress) {
          this.addLines(true)
        }
        this.serviceType =
          this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.paymentType?.id;
        this._fS.billPaybevInvoiceForm.patchValue({
          category:
            this.getPaymentDetail?.billDetails?.paybevPayment?.category?.id,
          class: this.getPaymentDetail?.billDetails?.paybevPayment?.class?.id,
          billNo: this.getPaymentDetail?.billDetails?.paybevPayment?.billNo,
          // billAttachment: this.getPaymentDetail?.billDetails?.paybevPayment?.billAttachmentURL,
          description:
            this.getPaymentDetail?.billDetails?.paybevPayment?.description,
          memo: this.getPaymentDetail?.billDetails?.paybevPayment?.memo,
          amount: this.getPaymentDetail?.billDetails?.paybevPayment?.amount,
          serviceFee: this.getPaymentDetail?.serviceFee,
          serviceRequest:
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails
              ?.paymentType?.id,
          paymentDate: this.getPaymentDetail?.estimatedArrivalDate
            .toString()
            .slice(0, -1),
        });
        this.serviceFee = this.getPaymentDetail?.serviceFee;
        // this.currentBillServiceFee =
        //   this.getPaymentDetail?.brooklynBillStatus == 1 ||
        //     this.getPaymentDetail?.brooklynBillStatus == 5 ||
        //     this.getPaymentDetail?.brooklynBillStatus == 6
        //     ? this.getPaymentDetail?.billDetails?.paybevPayment?.serviceFee
        //     : this.getPaymentDetail?.billDetails?.quickBookBill?.serviceFee;

        this.currentBillServiceFee = this.getPaymentDetail?.billDetails?.paybevPayment?.serviceFee

        this.currentQBOBillServiceFee = this.getPaymentDetail?.billDetails?.quickBookBill?.serviceFee;
        //get local date created on
        this.getPaymentDetail.createdOn = this._cS.getLocalDate(
          this.getPaymentDetail.createdOn
        );
        if (
          !(
            this.getPaymentDetail?.brooklynBillStatus == 1 ||
            this.getPaymentDetail?.brooklynBillStatus == 6
          )
        )
          this.previewQBOAttachment(
            this.getPaymentDetail?.billDetails?.quickBookBill?.qboAttachmentId
          );

        this.serviceFeeChange();
        if (this.getPaymentDetail?.billDetails?.paybevPayment?.class != null) {
          this.amountNumber =
            this.getPaymentDetail?.billDetails?.paybevPayment?.amount;
          this.formatAmount(this.amountNumber, true);
          this.formatServiceFee(this.serviceFee, true);
        }
        if (this.getPaymentDetail?.brooklynBillStatus == BrooklynBillStatus.PendingApproval) {
          this.amountNumber =
            this.getPaymentDetail?.billDetails?.paybevPayment?.amount;

          this.formatAmount(this.amountNumber, true);
          this.formatServiceFee(this.serviceFee, true);
        } else {
          this.amountNumber =
            this.getPaymentDetail?.billDetails?.quickBookBill?.amount;
          this.formatAmount(this.amountNumber, false);
          this.formatServiceFee(this.serviceFee, false);
        }

        this.paymentType =
          this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails?.paymentType?.name;
        if (this.paymentType == '' || this.paymentType == null) {
          this.paymentType = 'check';
        }
        this._fS.billForm.patchValue({
          programPeriod: this.getPaymentDetail?.program?.id,
          tags: this.getPaymentDetail?.tag?.id,
          isNonAlc: this.getPaymentDetail?.isNonAlc,
        });
        if (
          this.getPaymentDetail.billDetails.paybevPayment.class != null &&
          (this.getPaymentDetail?.brooklynBillStatus == 1 ||
            this.getPaymentDetail?.brooklynBillStatus == 6)
        ) {
          this.getUploadedW9AttachmentName =
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentName;
          this.getUploadedW9AttachmentUrl =
            this.getPaymentDetail?.vendorDetails?.payBevVendorDetails?.w9AttachmentURL;
          this.getUploadedBillAttachmentName =
            this.getPaymentDetail?.billDetails?.paybevPayment?.billAttachmentName;
          this.getUploadedBillAttachmentUrl =
            this.getPaymentDetail?.billDetails?.paybevPayment?.billAttachmentURL;

          this.filetype =
            this.getPaymentDetail?.billDetails?.paybevPayment?.billAttachmentName?.split(
              '.'
            )[1];
          if (
            this.filetype?.includes('image') ||
            this.filetype?.includes('png') ||
            this.filetype?.includes('jpg') ||
            this.filetype?.includes('gif') ||
            this.filetype?.includes('jpeg')
          ) {
            // this.getUploadedBillAttachmentUrl = this.getSafeUrl(
            //   this.getUploadedBillAttachmentUrl
            // );
          }
          this.getUploadedBillAttachmentUrl =
            this.getUploadedBillAttachmentUrl + '?t=' + new Date().getTime();

        } else {
          this.getUploadedBillAttachmentUrl = 'hello';
        }
        this.siteId = this.getPaymentDetail?.siteId;
        this.getTags();
        console.log(this.getPaymentDetail, 'getPaymentDetail', this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails
          ?.qboVendorId, 'qboVendorId', this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails
            ?.qboVendorId != null);
        if (
          this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails
            ?.qboVendorId != null
        ) {
          console.log('called');

          this.getInvestorPaybevBySiteId();
        }

        this.GetSiteNonAlcBalances();
        if (
          this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails
            ?.qboVendorId != null
        ) {
          for (const key in this._fS.billSiteVendorForm.controls) {
            if (!(key == 'vendor' || key == 'site')) {
              this._fS.billSiteVendorForm.get(key).clearValidators();
              this._fS.billSiteVendorForm
                .get(key)
                .updateValueAndValidity({ onlySelf: true });
            }
          }
        }

        if (this.getPaymentDetail?.brooklynBillStatus == 5) {
          for (const key in this._fS.billSiteVendorForm.controls) {
            if (!(key == 'vendor' || key == 'site'))
              this._fS.billSiteVendorForm.get(key).clearValidators();
            this._fS.billSiteVendorForm
              .get(key)
              .updateValueAndValidity({ onlySelf: true });
          }

          this._cS.markFormGroupTouched(this._fS.billPaybevInvoiceForm);

          this._cS.markFormGroupTouched(this._fS.billForm);
        }
      }
      this.isBillSkeleton = false;
    });
  }

  //function to resync bill data from QBO
  resynBillData() {
    this.isResyncingData = true;
    this._cpS
      .resyncPaymentData(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (response.result.isPaymentDeleted) {
            this._cS.displayMessage(
              'warning',
              'This transaction is deleted from QBO'
            );
            this.isResyncingData = false;
            this.handleCancel(response.result);
          } else {
            this._cS.displayMessage('success', response.message);

            this.getPaymentDetail = response.result;
            // this.currentBillServiceFee =
            //   this.getPaymentDetail?.brooklynBillStatus == 1 ||
            //     this.getPaymentDetail?.brooklynBillStatus == 5 ||
            //     this.getPaymentDetail?.brooklynBillStatus == 6
            //     ? this.getPaymentDetail?.billDetails?.paybevPayment?.serviceFee
            //     : this.getPaymentDetail?.billDetails?.quickBookBill?.serviceFee;
            this.currentBillServiceFee = this.getPaymentDetail?.billDetails?.paybevPayment?.serviceFee;
            this.currentQBOBillServiceFee = this.getPaymentDetail?.billDetails?.quickBookBill?.serviceFee;
            this.serviceFeeChange();
          }
        } else {
          this._cS.displayMessage('error', response.message);
        }
        this.isResyncingData = false;
      });
  }
  ApproveBill() {
    // if (this.mapValue == 'A') {
    //   for (const key in this._fS.billNewQbVendorForm.controls) {
    //     this._fS.billNewQbVendorForm.get(key).clearValidators();
    //     this._fS.billNewQbVendorForm.get(key).updateValueAndValidity();
    //   }
    // }
    Object.entries(this._fS.billSiteVendorForm.controls).forEach(([key, control]) => {
      const ctrl = control as AbstractControl;
    });
    if (
      this._fS.billSiteVendorForm.valid &&
      this._fS.billPaybevInvoiceForm.valid &&
      this._fS.billForm.valid
    ) {
      if (this.getUploadedBillAttachmentUrl) {
        this.isTransactionProcessing = true;
        this.isloadingApproveBill = true;
        var FormValuebillSiteVendorForm = this._fS.billSiteVendorForm.value;
        var FormValuebillPaybevInvoiceForm =
          this._fS.billPaybevInvoiceForm.value;
        var billFormValue = this._fS.billForm.value;
        var selectedProgram = this.listOfProgramPeriods?.find(
          (x: any) => x.id == billFormValue.programPeriod
        );
        var selectedClass = this.listOfTransactionClass?.find(
          (x: any) => x.id == FormValuebillPaybevInvoiceForm.class
        );
        var selectedCategory = this.listOfCategory?.find(
          (x: any) => x.id == FormValuebillPaybevInvoiceForm.category
        );
        var selectedServiceReq = this.listOfServiceType?.find(
          (x: any) => x.id == FormValuebillPaybevInvoiceForm.serviceRequest
        );
        var paymentData = this.getPaymentDetail;
        paymentData.siteId = this.siteId;
        paymentData.siteName = this.getSiteDetails?.name;
        paymentData.vendorDetails.payBevVendorDetails.vendorName =
          FormValuebillSiteVendorForm?.vendorName;
        paymentData.vendorDetails.payBevVendorDetails.vendorId =
          FormValuebillSiteVendorForm?.vendor;
        paymentData.vendorDetails.payBevVendorDetails.qboVendorId =
          FormValuebillSiteVendorForm?.qboEntityId;
        paymentData.vendorDetails.payBevVendorDetails.streetAddress1 =
          FormValuebillSiteVendorForm?.address1;
        paymentData.vendorDetails.payBevVendorDetails.streetAddress2 =
          FormValuebillSiteVendorForm?.address2;
        paymentData.vendorDetails.payBevVendorDetails.isAddLine =
          this.LineStreetAddress;
        paymentData.vendorDetails.payBevVendorDetails.city =
          FormValuebillSiteVendorForm?.city;
        paymentData.vendorDetails.payBevVendorDetails.state =
          FormValuebillSiteVendorForm?.state;
        paymentData.vendorDetails.payBevVendorDetails.zipCode =
          FormValuebillSiteVendorForm?.zipcode;
        paymentData.vendorDetails.payBevVendorDetails.country =
          FormValuebillSiteVendorForm?.country;
        paymentData.vendorDetails.payBevVendorDetails.email =
          FormValuebillSiteVendorForm?.emailAddress;
        paymentData.vendorDetails.payBevVendorDetails.mobileNumber = '';
        paymentData.vendorDetails.payBevVendorDetails.phoneNumber =
          FormValuebillSiteVendorForm?.phoneNumber;
        (paymentData.vendorDetails.payBevVendorDetails.terms = {
          id: '',
          name: '',
        }),
          (paymentData.vendorDetails.payBevVendorDetails.paymentType = {
            id: selectedServiceReq?.id,
            name: selectedServiceReq?.name,
          });
        (paymentData.vendorDetails.payBevVendorDetails.w9AttachmentURL = ''),
          // paymentData.vendorDetails.payBevVendorDetails.businessIdNo = FormValuebillSiteVendorForm?.businessIdNo

          (paymentData.estimatedArrivalDate =
            FormValuebillPaybevInvoiceForm?.paymentDate);
        paymentData.billDetails.paybevPayment.category = {
          id: selectedCategory?.id,
          name: selectedCategory?.name,
        };
        (paymentData.billDetails.paybevPayment.class = {
          id: selectedClass.id,
          name: selectedClass.name,
        }),
          (paymentData.billDetails.paybevPayment.billNo =
            FormValuebillPaybevInvoiceForm?.billNo);
        paymentData.description = FormValuebillPaybevInvoiceForm?.description;
        paymentData.amount = this.getPaymentDetail.brooklynBillStatus == BrooklynBillStatus.PendingApproval ? this.currentInvoiceAmount : this.currentQBOInvoiceAmount;

        paymentData.billDetails.paybevPayment.description =
          FormValuebillPaybevInvoiceForm?.description;
        paymentData.billDetails.paybevPayment.memo =
          FormValuebillPaybevInvoiceForm?.memo;
        paymentData.billDetails.paybevPayment.amount =
          this.currentInvoiceAmount;

        paymentData.billDetails.paybevPayment.serviceFee =
          this.currentBillServiceFee;
        paymentData.serviceFee = this.getPaymentDetail.brooklynBillStatus == BrooklynBillStatus.PendingApproval ? this.currentBillServiceFee : this.currentQBOBillServiceFee;
        paymentData.program = {
          id: billFormValue.programPeriod,
          name: selectedProgram?.label,
        };
        paymentData.tag = {
          id: billFormValue.tags,
          name: this.selectedTag,
          transcationids: [''],
        };
        paymentData.isNonAlc = billFormValue?.isNonAlc;
        this._cpS.billApprove(paymentData).subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            if (this.getPaymentDetail.underReviewInfo?.isMarkedAsUnderReview) {
              this.updateTransactionWithUnderRviewReason(false);
            }
            this.isTransactionProcessing = false;
            this._cS.displayMessage('success', response.message);
            //hide unit drawer
            this.isVisibleBillModal = false;
            this.hideExpenseDrawer.emit({
              hide: this.isVisibleBillModal,
              data: null,
            });
            this.isloadingApproveBill = false;
          } else {
            this.isTransactionProcessing = false;
            this._cS.displayMessage('error', response.message);
            this.isloadingApproveBill = false;
          }
        });
      } else {
        this._cS.displayMessage(
          'error',
          'Please upload bill attachment to proceed'
        );
      }
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.billSiteVendorForm);
      this._cS.markFormGroupTouched(this._fS.billPaybevInvoiceForm);
      this._cS.markFormGroupTouched(this._fS.billForm);
    }
  }

  mapVendorInQBO() {
    this.isLoadingMap = true;
    const formData = new FormData();
    formData.set('PaymentId', this.selectedData.id);
    formData.set('VendorId', this.mapVendorQboId);
    this._cpS.MapWithExistingVendor(formData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getPaymentDetail = response.result;
        // this.GetSiteVendorDetailbyVendorId();
        this._cS.displayMessage('success', response.message);
        this.isLoadingMap = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingMap = false;
      }
    });
  }

  UnmapVendorInQBO() {
    this.isLoadingUnlink = true;
    this._cpS.unlinkVendor(this.selectedData.id).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getPaymentDetail = response.result;
        this._cS.displayMessage('success', response.message);
        this.isLoadingUnlink = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingUnlink = false;
      }
    });
  }

  addLinesQBOSide() {
    this.LineStreetAddress = true
  }


  addLines(event) {
    this.LineStreetAddress = event;
    const form = this._fS.billSiteVendorForm.value;
    const paybevVendorDetails = this.getPaymentDetail?.vendorDetails?.payBevVendorDetails
    if (this.LineStreetAddress) {
      const address =
        (form.address1?.trim() ? form.address1.trim() + '\n' : '') +
        (form.address2?.trim() ? form.address2.trim() + '\n' : '') +
        (form.city?.trim() ? form.city.trim() + ', ' : '') +
        (form.state?.trim() ? form.state.trim() + ' ' : '') +
        (form.zipcode?.trim() ? form.zipcode.trim() + '\n' : '') +
        (form.address1?.trim() ||
          form.address2?.trim() ||
          form.city?.trim() ||
          form.state?.trim() ||
          form.zipcode?.trim()
          ? form.country ? form.country : ''
          : '');

      // localStorage.setItem('USAddress', JSON.stringify(form))

      this._fS.billSiteVendorForm.patchValue({
        // address1: address,
        // address2: "",
        // city: "",
        // state: "",
        // zipcode: "",
        // country: "",
        internationalAddress: address
      });
      if (address.trim() == '' && paybevVendorDetails?.isAddLine) {
        this._fS.billSiteVendorForm.patchValue({
          // address1: paybevVendorDetails.streetAddress1,
          internationalAddress: paybevVendorDetails.streetAddress1
        });
      }
      this._fS.billSiteVendorForm.get('address2').clearValidators();
      this._fS.billSiteVendorForm.get('address2').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('city').clearValidators();
      this._fS.billSiteVendorForm.get('city').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('state').clearValidators();
      this._fS.billSiteVendorForm.get('state').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('zipcode').clearValidators();
      this._fS.billSiteVendorForm.get('zipcode').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('country').clearValidators();
      this._fS.billSiteVendorForm.get('country').updateValueAndValidity();

    } else {

      // this._fS.billSiteVendorForm.get('city')!.setValidators(Validators.required);
      // this._fS.billSiteVendorForm.get('state')!.setValidators(Validators.required);
      // this._fS.billSiteVendorForm.get('zipcode')!.setValidators(Validators.required);
      // this._fS.billSiteVendorForm.get('country')!.setValidators(Validators.required);
      // this._fS.billSiteVendorForm.get('city').updateValueAndValidity();
      // this._fS.billSiteVendorForm.get('state').updateValueAndValidity();
      // this._fS.billSiteVendorForm.get('zipcode').updateValueAndValidity();
      // this._fS.billSiteVendorForm.get('country').updateValueAndValidity();

      if (paybevVendorDetails && !paybevVendorDetails.isAddLine) {
        this._fS.billSiteVendorForm.patchValue({
          address1: paybevVendorDetails.streetAddress1,
          address2: paybevVendorDetails.streetAddress2,
          city: paybevVendorDetails.city,
          state: paybevVendorDetails.state,
          zipcode: paybevVendorDetails.zipCode,
          country: paybevVendorDetails.country,
        });
      } else {
        // let USAddressFormValue = JSON.parse(localStorage.getItem('USAddress'));

        this._fS.billSiteVendorForm.patchValue({
          address1: '',
          address2: '',
          city: '',
          state: '',
          zipcode: '',
          country: '',
        });
      }

      // localStorage.removeItem('USAddress');
      this._fS.billSiteVendorForm.get('address1').setValidators([Validators.required]);
      this._fS.billSiteVendorForm.get('address1').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('city').setValidators([Validators.required]);
      this._fS.billSiteVendorForm.get('city').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('state').setValidators([Validators.required]);
      this._fS.billSiteVendorForm.get('state').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('zipcode').setValidators([Validators.required]);
      this._fS.billSiteVendorForm.get('zipcode').updateValueAndValidity();
      this._fS.billSiteVendorForm.get('country').setValidators([Validators.required]);
      this._fS.billSiteVendorForm.get('country').updateValueAndValidity();
    }
  }
  addLinesQbo() {
    this.LineStreetAddressQbo = true;

    this._fS.billNewQbVendorForm.patchValue({
      address1:
        this._fS.billNewQbVendorForm.get('address1').value != null &&
          this._fS.billNewQbVendorForm.get('address1').value != ''
          ? this._fS.billNewQbVendorForm.get('address1').value +
          '\r\n' +
          this._fS.billNewQbVendorForm.get('address2').value
          : this._fS.billNewQbVendorForm.get('address2').value +
            '\r\n' +
            this._fS.billNewQbVendorForm.get('city').value
            ? this._fS.billNewQbVendorForm.get('city').value + ', '
            : '' +
              (this._fS.billNewQbVendorForm.get('state').value
                ? this._fS.billNewQbVendorForm.get('state').value
                : '') +
              ' ' +
              this._fS.billNewQbVendorForm.get('zipcode').value
              ? this._fS.billNewQbVendorForm.get('zipcode').value
              : '' + '\r\n' + this._fS.billNewQbVendorForm.get('country').value
                ? this._fS.billNewQbVendorForm.get('country').value
                : '',
      address2: '',
      city: '',
      state: '',
      zipcode: '',
      country: '',
    });
  }

  createBill() {
    var FormValuebillSiteVendorForm = this._fS.billSiteVendorForm.value;
    var FormValuebillPaybevInvoiceForm = this._fS.billPaybevInvoiceForm.value;
    var billFormValue = this._fS.billForm.value;
    const invalid = [];
    const controls = this._fS.billSiteVendorForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    if (this.vendorBillDetails?.qboEntityId) {
      for (const key in this._fS.billSiteVendorForm.controls) {
        this._fS.billSiteVendorForm.get(key).clearValidators();
        this._fS.billSiteVendorForm.get(key).updateValueAndValidity();
      }
    }
    if (
      this._fS.billSiteVendorForm.valid &&
      this._fS.billPaybevInvoiceForm.valid &&
      this._fS.billForm.valid
    ) {
      if (this.uploadedFile) {
        this.isloadingAddUpdate = true;
        var selectedProgram = this.listOfProgramPeriods?.find(
          (x: any) => x.id == billFormValue.programPeriod
        );
        var selectedClass = this.listOfTransactionClass?.find(
          (x: any) => x.id == FormValuebillPaybevInvoiceForm.class
        );
        var selectedCategory = this.listOfCategory?.find(
          (x: any) => x.id == FormValuebillPaybevInvoiceForm.category
        );
        var selectedServiceReq = this.listOfServiceType?.find(
          (x: any) => x.id == FormValuebillPaybevInvoiceForm.serviceRequest
        );
        var date: any = this.datepipe.transform(
          FormValuebillPaybevInvoiceForm?.paymentDate,
          'yyyy-MM-dd'
        );
        const formData = new FormData();
        formData.set('SiteId', this.siteId);
        formData.set('SiteName', this.getSiteDetails?.name);
        formData.set(
          'VendorDetails.VendorName',
          FormValuebillSiteVendorForm?.vendorName
        );
        formData.set(
          'VendorDetails.VendorId',
          FormValuebillSiteVendorForm?.vendor
        );
        formData.set(
          'VendorDetails.QBOVendorId',
          this.vendorBillDetails?.qboEntityId
        );
        formData.set(
          'VendorDetails.StreetAddress1',
          FormValuebillSiteVendorForm?.address1
        );
        formData.set(
          'VendorDetails.StreetAddress2',
          FormValuebillSiteVendorForm?.address2
        );
        formData.set('VendorDetails.isAddLine', this.LineStreetAddress ? true + '' : false + '');
        formData.set('VendorDetails.City', FormValuebillSiteVendorForm.city);
        formData.set('VendorDetails.State', FormValuebillSiteVendorForm.state);
        formData.set(
          'VendorDetails.ZIPCode',
          FormValuebillSiteVendorForm.zipcode
        );
        formData.set(
          'VendorDetails.Country',
          FormValuebillSiteVendorForm.country
        );
        formData.set(
          'VendorDetails.Email',
          FormValuebillSiteVendorForm.siteVendoremailAddress
        );
        formData.set(
          'VendorDetails.PhoneNumber',
          FormValuebillSiteVendorForm.phoneNumber
        );
        formData.set('VendorDetails.MobileNumber', '');
        formData.set('VendorDetails.Terms.Id', '');
        formData.set('VendorDetails.Terms.Name', '');
        formData.set('VendorDetails.PaymentType.Id', selectedServiceReq?.id);
        formData.set(
          'VendorDetails.PaymentType.Name',
          selectedServiceReq?.name
        );
        formData.set('VendorDetails.W9AttachmentName', this.currentUploadedW9Attachment ? this.currentUploadedW9Attachment?.fileName : '');
        formData.set('VendorDetails.W9AttachmentURL', this.currentUploadedW9Attachment ? this.currentUploadedW9Attachment?.uri : '');
        formData.set('VendorDetails.QBOAttachmenName', '');
        formData.set('VendorDetails.QBOAttachmenURL', '');

        // formData.set('VendorDetails.BusinessIdNo', FormValuebillSiteVendorForm?.businessIdNo);

        formData.set('BillDetails.EstimatedArrivalDate', date);
        formData.set('BillDetails.Category.Id', selectedCategory?.id);
        formData.set('BillDetails.Category.Name', selectedCategory?.name);
        formData.set('BillDetails.Class.Id', selectedClass?.id);
        formData.set('BillDetails.Class.Name', selectedClass?.name);
        formData.set(
          'BillDetails.BillNo',
          FormValuebillPaybevInvoiceForm?.billNo
        );
        formData.set(
          'BillDetails.Description',
          FormValuebillPaybevInvoiceForm?.description
        );
        formData.set('BillDetails.Memo', FormValuebillPaybevInvoiceForm?.memo);
        formData.set('BillDetails.Amount', this.currentInvoiceAmount);
        formData.set('BillDetails.ServiceFee', this.currentBillServiceFee);
        formData.set('BillDetails.Program.Id', billFormValue.programPeriod);
        formData.set('BillDetails.Program.Name', selectedProgram.label);
        formData.set('BillDetails.Tag.Id', billFormValue.tags);
        formData.set('BillDetails.Tag.Name', this.selectedTag);
        formData.set('BillDetails.Tag.Transcationids', '[""]');
        formData.set('BillDetails.IsNonAlc', billFormValue?.isNonAlc);
        formData.set('Attachment', this.uploadedFile);

        this._cpS.CreateBill(formData).subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this._cS.displayMessage('success', response.message);
            this.isloadingAddUpdate = false;
            //hide unit drawer
            this.isVisibleBillModal = false;
            this.hideExpenseDrawer.emit({
              hide: this.isVisibleBillModal,
              data: null,
            });
          } else {
            this._cS.displayMessage('error', response.message);
            this.isloadingAddUpdate = false;
          }
        });
      } else {
        this._cS.displayMessage(
          'error',
          'Please upload bill attachment to proceed'
        );
      }
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.billSiteVendorForm);
      this._cS.markFormGroupTouched(this._fS.billPaybevInvoiceForm);
      this._cS.markFormGroupTouched(this._fS.billForm);
    }
  }
  updateBill(ur?: any) {
    const invalid = [];
    const controls = this._fS.billSiteVendorForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    var FormValuebillSiteVendorForm = this._fS.billSiteVendorForm.value;
    var FormValuebillPaybevInvoiceForm = this._fS.billPaybevInvoiceForm.value;
    var billFormValue = this._fS.billForm.value;

    if (this.getPaymentDetail?.billDetails?.paybevPayment.class == null) {
      for (const key in this._fS.billSiteVendorForm.controls) {
        this._fS.billSiteVendorForm.get(key).clearValidators();
        this._fS.billSiteVendorForm.get(key).updateValueAndValidity();
      }
    }
    if (this.getPaymentDetail?.billDetails?.paybevPayment.class == null) {
      for (const key in this._fS.billPaybevInvoiceForm.controls) {
        this._fS.billPaybevInvoiceForm.get(key).clearValidators();
        this._fS.billPaybevInvoiceForm.get(key).updateValueAndValidity();
      }
    }

    if (
      this.getPaymentDetail?.vendorDetails?.quickBookVendorDetails?.qboVendorId
    ) {
      for (const key in this._fS.billSiteVendorForm.controls) {
        if (key != 'site') {
          this._fS.billSiteVendorForm.get(key).clearValidators();
          this._fS.billSiteVendorForm.get(key).updateValueAndValidity();
        }
      }
    }


    if (
      this._fS.billSiteVendorForm.valid &&
      this._fS.billPaybevInvoiceForm.valid &&
      this._fS.billForm.valid
    ) {
      if (this.getUploadedBillAttachmentUrl) {
        this.isTransactionProcessing = true;
        ur
          ? (this.isloadingUnderReviewPayment = true)
          : (this.isloadingAddUpdate = true);
        setTimeout(() => {
          var selectedProgram = this.listOfProgramPeriods?.find(
            (x: any) => x.id == billFormValue.programPeriod
          );
          var selectedClass = this.listOfTransactionClass?.find(
            (x: any) => x.id == FormValuebillPaybevInvoiceForm.class
          );
          var selectedCategory = this.listOfCategory?.find(
            (x: any) => x.id == FormValuebillPaybevInvoiceForm.category
          );
          var selectedServiceReq = this.listOfServiceType?.find(
            (x: any) => x.id == FormValuebillPaybevInvoiceForm.serviceRequest
          );
          var paymentData = this.getPaymentDetail;
          paymentData.siteId = this.siteId;
          paymentData.amount = this.getPaymentDetail.brooklynBillStatus == BrooklynBillStatus.PendingApproval ? this.currentInvoiceAmount : this.currentQBOInvoiceAmount;
          paymentData.siteName = this.getPaymentDetail?.siteName;
          paymentData.vendorDetails.payBevVendorDetails.vendorName =
            FormValuebillSiteVendorForm?.vendorName;
          paymentData.vendorDetails.payBevVendorDetails.vendorId =
            FormValuebillSiteVendorForm?.vendor;
          paymentData.vendorDetails.payBevVendorDetails.qboVendorId =
            FormValuebillSiteVendorForm?.qboEntityId;
          paymentData.vendorDetails.payBevVendorDetails.streetAddress1 =
            FormValuebillSiteVendorForm?.address1;
          paymentData.vendorDetails.payBevVendorDetails.streetAddress2 =
            FormValuebillSiteVendorForm?.address2;
          paymentData.vendorDetails.payBevVendorDetails.isAddLine =
            this.LineStreetAddress;
          paymentData.vendorDetails.payBevVendorDetails.city =
            FormValuebillSiteVendorForm?.city;
          paymentData.vendorDetails.payBevVendorDetails.state =
            FormValuebillSiteVendorForm?.state;
          paymentData.vendorDetails.payBevVendorDetails.zipCode =
            FormValuebillSiteVendorForm?.zipcode;
          paymentData.vendorDetails.payBevVendorDetails.country =
            FormValuebillSiteVendorForm?.country;
          paymentData.vendorDetails.payBevVendorDetails.email =
            FormValuebillSiteVendorForm?.emailAddress;
          paymentData.vendorDetails.payBevVendorDetails.mobileNumber = '';
          paymentData.vendorDetails.payBevVendorDetails.phoneNumber =
            FormValuebillSiteVendorForm?.phoneNumber;
          paymentData.vendorDetails.payBevVendorDetails.terms = {
            id: '',
            name: '',
          };
          paymentData.vendorDetails.payBevVendorDetails.paymentType = {
            id: selectedServiceReq?.id,
            name: selectedServiceReq?.name,
          };
          paymentData.vendorDetails.payBevVendorDetails.w9AttachmentURL = paymentData.vendorDetails.payBevVendorDetails.w9AttachmentURL ? paymentData.vendorDetails.payBevVendorDetails.w9AttachmentURL : this.currentUploadedW9Attachment?.uri;
          // paymentData.vendorDetails.payBevVendorDetails.businessIdNo = FormValuebillSiteVendorForm?.businessIdNo
          paymentData.vendorDetails.payBevVendorDetails.w9AttachmentName = paymentData.vendorDetails.payBevVendorDetails.w9AttachmentName ? paymentData.vendorDetails.payBevVendorDetails.w9AttachmentName : this.currentUploadedW9Attachment?.fileName;

          paymentData.estimatedArrivalDate =
            FormValuebillPaybevInvoiceForm?.paymentDate;
          paymentData.billDetails.paybevPayment.category =
            this.getPaymentDetail.billDetails.paybevPayment.class == null
              ? null
              : {
                id: selectedCategory?.id,
                name: selectedCategory?.name,
              };
          paymentData.billDetails.paybevPayment.class =
            this.getPaymentDetail.billDetails.paybevPayment.class == null
              ? null
              : {
                id: selectedClass.id,
                name: selectedClass.name,
              };
          paymentData.billDetails.paybevPayment.billNo =
            FormValuebillPaybevInvoiceForm?.billNo;
          paymentData.description = FormValuebillPaybevInvoiceForm?.description;

          paymentData.billDetails.paybevPayment.description =
            FormValuebillPaybevInvoiceForm?.description;
          paymentData.billDetails.paybevPayment.memo =
            FormValuebillPaybevInvoiceForm?.memo;
          paymentData.billDetails.paybevPayment.amount =
            this.currentInvoiceAmount;
          paymentData.billDetails.paybevPayment.serviceFee =
            this.currentBillServiceFee;
          paymentData.serviceFee = this.currentBillServiceFee;
          paymentData.program = {
            id: billFormValue.programPeriod,
            name: selectedProgram?.label,
          };
          paymentData.tag = {
            id: billFormValue.tags,
            name: this.selectedTag,
            transcationids: [''],
          };
          paymentData.brooklynBillStatus = ur
            ? this.getPaymentDetail.brooklynBillStatus == 1
              ? 6
              : 1
            : this.getPaymentDetail.brooklynBillStatus;
          paymentData.isNonAlc = billFormValue?.isNonAlc;
          this._cpS.UpdateBill(paymentData).subscribe((response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this._cS.displayMessage('success', response.message);
              this.isloadingAddUpdate = false;
              this.isTransactionProcessing = false;
              //hide unit drawer
              this.isVisibleBillModal = false;
              this.isloadingUnderReviewPayment = false;
              this.hideExpenseDrawer.emit({
                hide: this.isVisibleBillModal,
                data: null,
              });
            } else {
              this.isTransactionProcessing = false;
              this.isloadingUnderReviewPayment = false;
              this._cS.displayMessage('error', response.message);
              this.isloadingAddUpdate = false;
            }
          });
        }, 200);
      } else {
        this._cS.displayMessage(
          'error',
          'Please upload bill attachment to proceed'
        );
      }
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.billSiteVendorForm);
      this._cS.markFormGroupTouched(this._fS.billPaybevInvoiceForm);
      this._cS.markFormGroupTouched(this._fS.billForm);
    }
  }
  currentUploadedW9Attachment: any
  handleChange(event: any): void {
    if (event.type == 'success' || event.type == 'error') {
      const reader = new FileReader();
      reader.readAsDataURL(this.uploadedFileW9Attachment);
      reader.onload = () => {
        var str = reader.result;
        this.uploadFlagW9Attachment = true;
        var FormValuebillSiteVendorForm = this._fS.billSiteVendorForm.value;
        const formDataAttachment = new FormData();
        if (this.selectedData?.id != undefined) {
          formDataAttachment.set('PaymentId', this.selectedData?.id);
        }
        formDataAttachment.set('VendorId', FormValuebillSiteVendorForm?.vendor);
        formDataAttachment.set(
          'W9AttachmentFile',
          this.uploadedFileW9Attachment
        );
        this._cpS
          .UploadW9AttachmentFile(formDataAttachment)
          .subscribe((response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this._cS.displayMessage('success', response.message);
              this.currentUploadedW9Attachment = response.result;
              this.isLoadingOne = false;
              this.currentUploadedW9Attachment = response.result;
            } else {
              this._cS.displayMessage('error', response.message);
              this.isLoadingOne = false;
            }
          });
      };
    }
  }

  checkTagGroupData(event: any) {
    var selectedGroup: any;
    var selectedTag: any;
    this.listOfTags.forEach((element: any) => {
      element.Tags.forEach((tag: any) => {
        if (tag._id == event) {
          selectedTag = tag;
          selectedGroup = element;
        }
      });
    });
    this.selectedTagGroup = selectedGroup;
    this.selectedTag = selectedTag?.Name;
  }

  getTags() {
    if (this.siteId) {
      this.isLoadingTags = true;
      this._cpS.getTagsDropdownList(this.siteId).subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.listOfTags = response.result;
            this.listOfUnfilteredTags = JSON.parse(
              JSON.stringify(response.result)
            );
            // response.result.forEach((tagGroup: any) => {
            //   tagGroup.Tags.forEach((tag: any) => {
            //     this.listOfTags.push({
            //       tagGroupName: tagGroup.Name,
            //       id: tag._id,
            //       tagName: tag.Name,
            //     });
            //   });
            // });
            var defaultTagGroup = this.listOfTags?.find(
              (x: any) => x?.Name == 'Uncategorized'
            );
            if (this.selectedData == null) {
              this._fS.billForm.patchValue({
                tags: defaultTagGroup?.Tags[0]._id,
              });
              this.checkTagGroupData(defaultTagGroup?.Tags[0]._id);
            }
            if (this.selectedData != null) {
              this.checkTagGroupData(this.getPaymentDetail?.tag?.id);
            }
            this.isLoadingTags = false;
          } else {
            this.isLoadingTags = false;
            this._cS.displayMessage('error', response.message);
            this.listOfTags = [];
          }
        },
        (error: any) => {
          this.isLoadingTags = false;
          this.listOfTags = [];
        }
      );
    }
  }
  searchTagGroupAndTags(searchTerm) {
    // Make the search term case insensitive
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    const result = this.listOfTags
      .map((item) => {
        // Check if the event's Name matches the search term
        const isNameMatch =
          item.Name.toLowerCase().includes(lowerCaseSearchTerm);

        // Filter the tags that match the search term
        const matchingTags = item.Tags.filter((tag) =>
          tag.Name.toLowerCase().includes(lowerCaseSearchTerm)
        );

        // If the event name matches, include the whole item with all tags
        if (isNameMatch) {
          return {
            ...item,
            Tags: item.Tags,
          };
        }

        // If there are matching tags, include the item with only those tags
        if (matchingTags.length > 0) {
          return {
            ...item,
            Tags: matchingTags,
          };
        }

        // Otherwise, exclude this item
        return null;
      })
      .filter((item) => item !== null);

    // Output the result
    return result;
  }
  returnFilteredTags(searchTerm) {
    if (searchTerm) {
      const filteredResult = this.searchTagGroupAndTags(searchTerm);
      this.listOfTags = filteredResult;
    } else {
      this.listOfTags = this.listOfUnfilteredTags;
    }
  }
  deleteBill() {
    const formData = new FormData();
    formData.set('InvestmentId', this.selectedData.id);
    this._cpS
      .deletePayment(this.selectedData?.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          this.isVisibleBillModal = false;
          this.hideExpenseDrawer.emit({
            hide: this.isVisibleBillModal,
            data: null,
          });
        } else {
          this._cS.displayMessage('error', response.message);
        }
      });
  }

  preventDefaults(event: any) {
    event.preventDefault();
    return false;
  }

  getEstDeliveryDate() {
    if (
      this._fS.billPaybevInvoiceForm?.value?.amount &&
      this._fS.billPaybevInvoiceForm?.value?.serviceRequest
    ) {
      var date = new Date();
      // this.paymentType = this.paymentType;
      var daysToadd: any = 0;
      let extraDays = 0;
      date.getHours() < 14 ? (extraDays = 0) : (extraDays = 1);
      if (
        Number(this._fS.billPaybevInvoiceForm.value.serviceRequest) == 1 ||
        Number(this._fS.billPaybevInvoiceForm.value.serviceRequest) == 3
      ) {
        daysToadd = 1 + extraDays;
      } else {
        if (this._fS.billPaybevInvoiceForm?.value?.amount <= 10000) {
          if (
            this.paymentType.toLowerCase() == 'ePayment'.toLowerCase() ||
            this.paymentType.toLowerCase() == 'Credit Card'.toLowerCase() ||
            this.paymentType.toLowerCase() == 'Wire Transfer'.toLowerCase()
          ) {
            daysToadd = 2 + extraDays;
          } else {
            daysToadd = 4 + extraDays;
          }
        } else {
          if (
            this.paymentType.toLowerCase() == 'ePayment'.toLowerCase() ||
            this.paymentType.toLowerCase() == 'Credit Card'.toLowerCase() ||
            this.paymentType.toLowerCase() == 'Wire Transfer'.toLowerCase()
          ) {
            daysToadd = 4 + extraDays;
          } else {
            daysToadd = 5 + extraDays;
          }
        }
      }
      date.setDate(date.getDate() + 1);
      for (let index = 0; index < daysToadd; index++) {
        let isWorkingDay = this.checkIfWorkingDay(date);
        if (isWorkingDay == false) {
          daysToadd++;
        }
        date.setDate(date.getDate() + 1);
      }
      var Newdate = new Date();
      Newdate.setDate(Newdate.getDate() + daysToadd);
      this.estDeliveryDate = Newdate;
      //this.getPaymentDetail.estimatedArrivalDate != this._fS.billPaybevInvoiceForm.value.paymentDate
      if (this.selectedData == null)
        this._fS.billPaybevInvoiceForm.patchValue({
          paymentDate: this.estDeliveryDate,
        });
    }
  }

  serviceTypeChanged() {
    if (
      Number(this._fS.billPaybevInvoiceForm.value.serviceRequest) == 1 ||
      Number(this._fS.billPaybevInvoiceForm.value.serviceRequest) == 3
    ) {
      this.serviceType = this._fS.billPaybevInvoiceForm.value.serviceRequest;

      this._fS.billPaybevInvoiceForm.patchValue({
        serviceFee: 50,
      });
      this.formatServiceFee(50, true);
      this.serviceFee = 50;
    } else if (
      Number(this._fS.billPaybevInvoiceForm.value.serviceRequest) == 2
    ) {
      this.serviceType = this._fS.billPaybevInvoiceForm.value.serviceRequest;
      this._fS.billPaybevInvoiceForm.patchValue({
        serviceFee: 0,
      });
      this.serviceFee = 0;
    }
    this.formatServiceFee(
      this._fS.billPaybevInvoiceForm.get('serviceFee').value, true
    );
    // if (patchUpdated) {
    this.getEstDeliveryDate();
    // }
  }

  checkIfWorkingDay(date: any) {
    var dt = this.datepipe.transform(date, 'M/d/yyyy');
    if (holidayArray.includes(dt)) {
      return false;
    } else if (date.getDay() == 6) {
      return false;
    } else if (date.getDay() == 0) {
      return false;
    } else {
      return true;
    }
  }

  tabEvent(index: number) {
    if (index == 1) {
      this.tabIndex = 2;
      this.previewQBOAttachment(
        this.getPaymentDetail?.billDetails?.quickBookBill?.qboAttachmentId
      );
    }
  }

  formatAmount(amount: any, isPaybevAmount: boolean) {
    if (amount) {
      if (amount.toString().includes('$')) {
        amount = amount.split('$')[1];
      }
      amount = amount.toString().replace(',', '');
      if (isPaybevAmount) {
        this.currentInvoiceAmount = Number(amount);
        this._fS.billPaybevInvoiceForm.patchValue({
          amount: this.currency.transform(amount),
        });
        this.amountNumber = this.currency.transform(amount);
      } else {
        this.currentQBOInvoiceAmount = Number(amount);
      }
    }
  }
  formatServiceFee(serviceFee: any, isPaybevFee: boolean) {
    if (serviceFee != null) {
      if (serviceFee.toString().includes('$')) {
        serviceFee = serviceFee.split('$')[1];
      }
      serviceFee = serviceFee.toString().replace(',', '');
      if (isPaybevFee) {
        this.currentBillServiceFee = Number(serviceFee);
        this._fS.billPaybevInvoiceForm.patchValue({
          serviceFee: this.currency.transform(serviceFee),
        });
        this.serviceFee = this.currency.transform(serviceFee);
      } else {
        this.currentQBOBillServiceFee = Number(serviceFee);
      }
    }
  }

  previewQBOAttachment(qboAttachmentId: any) {
    this.isLoadingQBOLink = true;
    if (qboAttachmentId != null && qboAttachmentId != 'null') {
      this._cpS
        .PreviewQBOAttachment(qboAttachmentId)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            // if (this.tabIndex == 2) {
            // this.qboOriginalbillLink = response.result.tempDownloadUri
            this.qboOriginalbillLink = response.result.tempDownloadUri;
            let temptUrl = response.result.tempDownloadUri;
            this.filetype = response.result.contentType;
            if (
              this.filetype.includes('image') ||
              this.filetype?.includes('png') ||
              this.filetype?.includes('jpg') ||
              this.filetype?.includes('gif') ||
              this.filetype?.includes('jpeg')
            ) {
              this.qboOriginalbillLink = this.getSafeUrl(
                response.result.tempDownloadUri
              );
              this.getUploadedBillAttachmentUrl = this.getSafeUrl(
                response.result.tempDownloadUri
              );
            } else {
              this.getUploadedBillAttachmentUrl = temptUrl;
            }
            // this.getUploadedBillAttachmentUrl =
            //   this.getUploadedBillAttachmentUrl + '?t=' + new Date().getTime();
            // console.log(
            //   'getUploadedBillAttachmentUrl',
            //   this.getUploadedBillAttachmentUrl
            // );

            this.isLoadingQBOLink = false;
            // } else {
            this.vendorDropDownLink = this.getSafeUrl(
              response.result.tempDownloadUri
            );
            this.isLoadingQBOLink = false;
            // }
          } else {
            this._cS.displayMessage('error', response.message);
            this.isLoadingQBOLink = false;
          }
        });
    } else {
      this.isLoadingQBOLink = false;
    }
  }

  //Non_alc Listing
  GetSiteNonAlcBalances() {
    this._cpS.GetSiteNonAlcBalance(this.siteId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.nonalcResult = response.result;
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  getSecondPart(str: any) {
    return str.split('.')[1];
  }
  // to remove error : Error: unsafe value used in a resource URL context
  getSafeUrl(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  mapValueChange() {
    var billSiteVendorFormValue = this._fS.billSiteVendorForm.value;
    if (this.mapValue == 'B') {
      var defaultNetTerms = this.listOfTerms?.find((x: any) =>
        x.name.includes('Due')
      );
      let address = '';
      if (this.LineStreetAddress) {
        const form = this._fS.billSiteVendorForm.value;

        address =
          (form.address1?.trim() ? form.address1.trim() + '\n' : '') +
          (form.address2?.trim() ? form.address2.trim() + '\n' : '') +
          (form.city?.trim() ? form.city.trim() + ', ' : '') +
          (form.state?.trim() ? form.state.trim() + ' ' : '') +
          (form.zipcode?.trim() ? form.zipcode.trim() + '\n' : '') +
          (form.address1?.trim() ||
            form.address2?.trim() ||
            form.city?.trim() ||
            form.state?.trim() ||
            form.zipcode?.trim()
            ? form.country ? form.country : ''
            : '');
      }
      this._fS.billNewQbVendorForm.patchValue({
        vendorName: billSiteVendorFormValue.vendorName,
        companyName: billSiteVendorFormValue.vendorName,
        address1: this.LineStreetAddress ? address : billSiteVendorFormValue.address1,
        address2: billSiteVendorFormValue.address2,

        city: billSiteVendorFormValue.city,
        state: billSiteVendorFormValue.state,
        zipcode: billSiteVendorFormValue.zipcode,
        country: billSiteVendorFormValue.country,
        phoneNumber: billSiteVendorFormValue.phoneNumber,
        emailAddress: billSiteVendorFormValue.siteVendoremailAddress,
        netTerms: defaultNetTerms.id,
      });

      this.LineStreetAddressQbo = this.LineStreetAddress;
    }
  }

  serviceFeeChange() {
    this.NetAmount = -(
      (this.getPaymentDetail?.brooklynBillStatus == 1 ||
        this.getPaymentDetail?.brooklynBillStatus == 6 ||
        this.getPaymentDetail?.brooklynBillStatus == 5
        ? Number(this.getPaymentDetail?.billDetails?.paybevPayment?.amount)
        : Number(this.getPaymentDetail?.billDetails?.quickBookBill?.amount)) +
      this.currentBillServiceFee
    );
  }

  downloadAttachment() {
    window.open(this.getUploadedBillAttachmentUrl, '_blank');
  }

  updateQboVendor() {
    this.isLoadingOne = true;
    var FormValuebillSiteVendorForm = this._fS.billSiteVendorForm.value;
    var vendorData = {
      paymentId: this.selectedData.id,
      qboEntityId: this.getPaymentDetail?.qboVendorId,
      phoneNumber: FormValuebillSiteVendorForm?.phoneNumber,
      streetAddress1: FormValuebillSiteVendorForm?.address1,
      streetAddress2: FormValuebillSiteVendorForm?.address2,
      city: FormValuebillSiteVendorForm?.city,
      state: FormValuebillSiteVendorForm?.state,
      zipCode: FormValuebillSiteVendorForm?.zipcode,
      country: FormValuebillSiteVendorForm?.country,
    };

    this._cpS.updateQBOVendor(vendorData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getPaymentDetail = response.result;
        this._cS.displayMessage('success', response.message);
        this.isLoadingOne = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }

  zoomInPDF() {
    if (this.pdfZoom < 5) {
      this.pdfZoom += 0.25;
    }
  }
  zoomOutPDF() {
    if (this.pdfZoom > 0.25) {
      this.pdfZoom -= 0.25;
    }
  }

  focusElement(event, element, isTextField?: any) {
    if (event && this.selectedData == null) {
      if (!isTextField) {
        element.focus();
      } else {
        element.nativeElement.focus();
      }
    }
  }
  ngOnDestroy() {
    this.getUploadedBillAttachmentUrl = null;
  }
}
